import React, { useState, useEffect, useCallback } from "react";
import { useMemo, useRef } from "react";
import { Grid, Tooltip } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import SearchIcon from "@material-ui/icons/Search";
import { CloseOutlined } from "@material-ui/icons/";
// import Loader from "../../biztran_controls/Loader";

const columns = [
  {
    field: "ModelCode",
    headerName: "ModelCode",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 160,
  },
  {
    field: "Quantity",
    headerName: "Qty",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 130,
    type: "number",
    editable: true,
    renderCell: (params) => (
      <Tooltip title={params.row.Quantity} >
        <span className="table-cell-trucate">
          {/* {params.row.Quantity != 1 || params.row.Quantity != 0 ? 1 : params.row.Quantity} */}
          {params.row.Quantity > 1 ? params.row.Quantity : 1}
        </span>
      </Tooltip>
    )
    // valueGetter: GetQuantity,
  },
  {
    field: "Description",
    headerName: "Description",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 260,
    renderCell: (params) => (
      <Tooltip title={params.row.Description} >
        <span className="table-cell-trucate">{params.row.Description}</span>
      </Tooltip>
    )
  },
  {
    field: "ListPriceINR",
    headerName: "Rate",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 160,
    type: "number",
  },
  {
    field: "ListPriceUSD",
    headerName: "UsdRate",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 160,
    type: "number",
  },
  {
    field: "Amount",
    headerName: "Amount",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 180,
    type: "number",
    valueGetter: GetAmount,
    // sortComparator: (v1, v2) => v1.toString().localeCompare(v2.toString()),
  },
  {
    field: "ProductName",
    headerName: "Product",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 180,
    renderCell: (params) => (
      <Tooltip title={params.row.ProductName} >
        <span className="table-cell-trucate">{params.row.ProductName}</span>
      </Tooltip>
    )
  },
  {
    field: "ProductCat1",
    headerName: "Cat1",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 180,
    renderCell: (params) => (
      <Tooltip title={params.row.ProductCat1} >
        <span className="table-cell-trucate">{params.row.ProductCat1}</span>
      </Tooltip>
    )
  },

];



function useApiRef() {
  // debugger;
  const apiRef = useRef(null);
  const _columns = useMemo(
    () =>

      columns.concat({
        field: "__HIDDEN__",
        width: 0,
        renderCell: (params) => {
          apiRef.current = params.api;
          return null;
        },
      }),
    [columns]
  );
  return { apiRef, columns: _columns };
}



function GetAmount(params) {
  var Q = params.getValue(params.id, "Quantity");
  var R = params.getValue(params.id, "Rate");
  let Total = Q * R;
  return Total;
}

// function GetQuantity(params) {
//// debugger;
// var Q = "1";
// var Q = params.getValue(params.id, "Quantity");;
// if (params.getValue(params.id, "Quantity" != undefined)) {
//   Q = params.getValue(params.id, "Quantity");
// }
//   return Q;
// }


const AddProduct = (props) => {
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [cellchanged, setCellchanged] = React.useState([]);
  const [ProductList, setProductList] = useState("");
  const [List, setList] = useState([]);
  const [Count, setCount] = useState("");
  const [rows, setRows] = useState([]);
  const [row, setRow] = useState([]);
  const { apiRef, columns } = useApiRef();
  const [CurrencyID, setCurrencyID] = useState("");
  const [Mode, setMode] = useState("");
  const [Column, setColumn] = useState("");
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const [StateResponse, fetchState] = UseFetchData();
  const [ConversionResopnse, fetchConversion] = UseFetchData();
  const [isEditOpen, setEditOpen] = useState();
  const [QTID, SetQTID] = useState("");
  const [StateName, setStateName] = useState("");
  const [ConversionRate, setConversionRate] = useState("");
  const [EditQTID, setEditQTTID] = useState("");
  const [QuotationdtldID, setQuotationdtldID] = useState("");
  const [response, fetchData] = UseFetchData();
  const [ProductListresponse, FetchProductListData] = UseFetchData();
  const [Productcmb, setProductcmb] = useState([]);
  const [ProductName, setProductNamecmb] = useState([]);
  const [ProductGroupcmb, setProductGroupcmb] = useState([]);
  const [ProductCat1cmb, setProductCat1cmb] = useState([]);
  const [ProductCat2cmb, setProductCat2cmb] = useState([]);
  const [ProductCat3cmb, setProductCat3cmb] = useState([]);
  const [ProductCat4cmb, setProductCat4cmb] = useState([]);
  const [ProductID, setProductID] = useState("");
  const [ProductGroupID, setProductGroupID] = useState("");
  const [ProductCat1ID, setProductCat1ID] = useState("");
  const [ProductCat2ID, setProductCat2ID] = useState("");
  const [ProductCat3ID, setProductCat3ID] = useState("");
  const [ProductCat4ID, setProductCat4ID] = useState("");
  const [Description, setDescription] = useState("");
  const [Cat1, setCat1] = useState("");
  const [SearchString, setSearchString] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageName, setpageName] = useState(props.pageName);
  const [ProductSKUID, setProductSKUID] = useState("");
  const [ModelCode, setModelCode] = useState("");



  useEffect(() => {
    setLoading(false);
    setRows(ProductListresponse);
  }, [ProductListresponse]);

  const validationSchema = Yup.object({
  });


  useEffect(() => {
    debugger
    if (props.QuotationDtlsData != null && props.QuotationDtlsData.length > 0) {
      setLoading(false);
      setRow(props.QuotationDtlsData);
    }
  }, [props.QuotationDtlsData]);

  const onSubmit = async () => {
    debugger;
    try {
      let gridcolumns = apiRef.current.getRowModels();
      var newSelection = selectionModel;
      let Seq = 0;
      if (selectionModel.length > 0) {
        for (var i = 0; i < newSelection.length; i++) {
          var idd = newSelection[i];
          let iterator = gridcolumns.entries();
          for (let e of iterator) {
            var id = e[0];
            if (idd === id) {
              Seq += 1;
              let Quty = 1;
              let Quantitys = e[1].Quantity;
              var bodyFormData = new FormData();
              var QDID = "";
              if (pageName == "NCR") {
                for (var i = 0; i < newSelection.length; i++) {
                  if (newSelection.length > 1) {
                    alert("Only one Product Can Modified At a Time!");
                  }
                  else {
                    // var idd = newSelection[i];
                    let iterator = gridcolumns.entries();
                    for (let e of iterator) {
                      var id = e[0];
                      if (idd === id) {
                        let Model_Code = e[1].ModelCode
                        let Description = e[1].Description
                        var QDID = "";
                        if (ProductGroupID != "") {
                          props.setProductID(e[1].ProductID);
                        }
                        else {
                          props.setProductID(ProductID);
                        }
                        props.setProductSKUID(id);
                        props.setModelCode(Model_Code);
                        props.setDescription(Description);
                        props.setOpen(false);
                      }
                    }
                  }
                }
              }
              else {
                if (props.QuotationdtldID != undefined && props.QuotationdtldID == "" && props.QuotationdtldID == null) {
                  bodyFormData.append("QuotationDtlsID", props.QuotationdtldID);
                }
                else {
                  bodyFormData.append("QuotationDtlsID", QDID);
                }
                bodyFormData.append("QuotationID", props.QTID);
                bodyFormData.append("Seq", Seq);
                bodyFormData.append("ProductSKUID", id);
                bodyFormData.append("Description", e[1].Description);
                bodyFormData.append("Specification", e[1].Specifications);
                if (Quantitys == undefined && Quantitys == null) {
                  bodyFormData.append("Quantity", parseFloat(Quty));
                }
                else {
                  bodyFormData.append("Quantity", parseInt(e[1].Quantity));
                }
                bodyFormData.append("Rate", parseFloat(e[1].ListPriceUSD));
                bodyFormData.append("RateINR", parseFloat(e[1].ListPriceINR));
                bodyFormData.append("DiscountPer", "0");
                bodyFormData.append("DiscountAmt", "0");
                bodyFormData.append("CurrencyID", CurrencyID);
                bodyFormData.append("ConvFactor", ConversionRate);
                bodyFormData.append("CUrrencyRate", "0");
                if (Quantitys == undefined && Quantitys == null) {
                  bodyFormData.append("Amount", Quty * e[1].Rate);
                }
                else {
                  bodyFormData.append("Amount", e[1].Quantity * e[1].Rate);
                }
                bodyFormData.append("CgstPer", parseFloat(e[1].GstPer));
                bodyFormData.append("CgstAmt", "0");
                bodyFormData.append("SgstPer", parseFloat(e[1].GstPer));
                bodyFormData.append("SgstAmt", "0");
                bodyFormData.append("IgstPer", parseFloat(e[1].GstPer));
                bodyFormData.append("IgstAmt", "0");
                bodyFormData.append("StateName", StateName);
                bodyFormData.append("NetWeight", e[1].ShippingWeight);
                if (Quantitys == undefined && Quantitys == null) {
                  bodyFormData.append("TotalAmount", Quty * e[1].ListPriceUSD);
                }
                else {
                  bodyFormData.append("TotalAmount", e[1].Quantity * e[1].ListPriceUSD);
                }
                if (Quantitys == undefined && Quantitys == null) {
                  bodyFormData.append("TotalAmountINR", Quty * e[1].ListPriceINR);
                }
                else {
                  bodyFormData.append("TotalAmountINR", e[1].Quantity * e[1].ListPriceINR)
                }
                await fetchData("Quotation/AddProduct", bodyFormData);
                setLoading(true);
              }
            }
          }
        }
        if (pageName == 'NCR') {
        }
        else {
          alert("Product is Added Sucessfully")
        }
      }
      else {
        alert("Please Select Product To Add");
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (response.Response === true) {
      setProductID("");
      setProductGroupID("");
      props.getByIDData();
      setLoading(false);
    } else if (response.Response === false) {
      if (response.Message.includes("Already") === true) {
        alert(response.Message);
        setLoading(false);

      } else {
        alert("Failed.");
        setLoading(false);

      }
    }
  }, [response]);

  // const ProductData = React.useCallback((options) => {
  //   if (options !== undefined) {
  //     let Product = options.map((data) => (
  //       <option key={data.ProductName} value={data.ProductID}>
  //         {data.ProductName}
  //       </option>
  //     ));
  //     setProductcmb(Product);
  //   }
  // }, []);


  const ProductGroupData = useCallback((options) => {
    if (options !== undefined) {
      let ProductGroup = options.map((data) => (
        <option key={data.ProductGroup} value={data.ProductGroupID}>
          {data.ProductGroup}
        </option>
      ));
      setProductGroupcmb(ProductGroup);
    }
  }, []);


  const ProductcmbData = (PGID) => {
    debugger;
    var id = "";
    if (PGID !== "") {
      id = PGID;
    } else if (ProductGroupID !== "") {
      id = ProductGroupID;
    } else {
      id = "";
    }
    let options = ComboDataResponse["Product"];
    if (options !== undefined) {
      if (id !== "") {
        let Product = options
          .filter((option) => option.ProductGroupID === id)
          .map((data) => (
            <option key={data.ProductName} value={data.ProductID}>
              {data.ProductName}
            </option>
          ));
        setProductcmb(Product);
      }
      else {
        let Product = options.map((data) => (
          <option key={data.ProductName} value={data.ProductID}>
            {data.ProductName}
          </option>
        ));
        setProductcmb(Product);
      }
    }
  };




  useEffect(() => {
    // debugger;
    if ((response.Response === true) && (Mode === 'Insert')) {
      alert('Data Saved Succesfully.');
      props.setOpen(false);
      props.PopulateData();
      setLoading(false);
    }
    else if (response.Response === false) {
      alert('Failed.');
      setLoading(false);

    }
  }, [response]);


  useEffect(() => {
    if (ComboDataResponse !== undefined) {
      if (ComboDataResponse["Product"] !== undefined) {
        setLoading(false);
        ProductcmbData(ComboDataResponse["Product"]);
      }
      else {
        ProductcmbData([]);
      }
      if (ComboDataResponse["ProductGroup"] !== undefined) {
        setLoading(false);
        ProductGroupData(ComboDataResponse["ProductGroup"]);
      }
      else {
        ProductGroupData([]);
      }
      if (props.QuotationID !== "") {
        ProductcmbData("");
        setMode("Update");
      } else {
        setMode("Insert");
      }
    }
  }, [ComboDataResponse]);


  useEffect(() => {
    GetComboData();
  }, [ProductID, ProductGroupID]);

  useEffect(() => {
    debugger;
    if (StateResponse !== undefined) {
      if (StateResponse["StateData"] !== undefined) {
        // debugger;
        setStateName(StateResponse["StateData"][0]["StateName"]);
        // debugger;
      }
    }
  }, [StateResponse]);


  useEffect(() => {
    debugger;
    if (ConversionResopnse !== undefined) {
      if (ConversionResopnse["ConversionData"] !== undefined) {
        setConversionRate(ConversionResopnse["ConversionData"][0]["ConversionRate"]);
        setCurrencyID(ConversionResopnse["ConversionData"][0]["CurrencyID"]);
      }
    }
  }, [ConversionResopnse]);



  useEffect(() => {
    GetComboData();
    GetStateDate();
    GetConversionDate();
  }, []);

  const GetStateDate = () => {
    // debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("QuotationID", props.QTID);
    fetchState("Quotation/StateData", bodyFormData);
  }

  const GetConversionDate = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("QuotationID", props.QTID);
    fetchConversion("Quotation/ConversionData", bodyFormData);
  }


  const GetComboData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("ProductID", ProductID);
    bodyFormData.append("ProductGroupID", ProductGroupID);
    setLoading(true);
    fetchComboData("Quotation/ComboDataAddProduct", bodyFormData);
  };

  const onSelectChange = (e) => {
    debugger;
    let targetvalue = e.target.value;
    let targetname = e.target.name;
    if (targetvalue !== "") {
      if (targetname === "ProductID") {
        setProductID(targetvalue);
      }
      if (targetname === "ProductGroupID") {
        setProductGroupID(targetvalue);
        ProductcmbData(targetvalue);
      }
    }
    else {
      if (targetname === "ProductID") {
        setProductID("");
      }
      if (targetname === "ProductGroupID") {
        setProductGroupID("");
        setProductcmb([]);
        setProductCat1ID("");
      }

    }
  };

  const PopulateData = () => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("QuotationdtlsID", props.QuotationdtldID);
    bodyFormData.append("ProductID", ProductID);
    bodyFormData.append("ProductGroupID", ProductGroupID);
    bodyFormData.append("Cat1", Cat1);
    bodyFormData.append("Description", Description);
    bodyFormData.append("SearchString", SearchString);
    setLoading(true);
    FetchProductListData("Quotation/ProductList", bodyFormData);
  };


  const handleCellEditCommit = React.useCallback(

    ({ id, field, value }) => {
      // debugger;
      setCellchanged(value)
      if (field === "Amount") {
        const [Quantity, Rate] = value.toString().split(" ");
        const updatedRows = rows.map((row) => {
          if (row.id === id) {
            return { ...row, Quantity, Rate };
          }
          return row;
        });
        setRows(updatedRows);

      }
    },
    [rows]
  );


  useEffect(() => {
    // setRow(selectionModel);
    if (selectionModel.length > 0) {
      let gridcolumns = apiRef.current.getRowModels();
      let iterator = gridcolumns;
      let data = Array.from(iterator);
      data = Object.values(data);
      data = Object.keys(data).map(key => (data[key][1]))
      const filterOptions = selectionModel;
      let result = data.filter(function (e) {
        return filterOptions.includes(e.id)

      });
      setRow(result);

    }
  }, [selectionModel, cellchanged]);


  return (


    <Grid xs={12}>

      {/* {
        loading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 10,
          }}>
            <Loader />
          </div>
        )
      } */}
      <Formik
        initialValues={{}}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <Grid spacing={2} container direction="row" xs={12}>
                <Grid item xs={1}>
                  <label
                    htmlFor={"ProductGroupID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"ProductGroup"}
                  </label>
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="select"
                    name="ProductGroupID"
                    options={ProductGroupcmb}
                    onChange={onSelectChange}
                  />
                </Grid>
                <Grid item xs={1}>
                  <label
                    htmlFor={"ProductID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Product"}
                  </label>
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="select"
                    name="ProductID"
                    options={Productcmb}
                    onChange={onSelectChange}
                  />
                </Grid>
                <Grid item xs={1}>
                  <label
                    htmlFor={"Cat-1"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Cat-1"}
                  </label>
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    name="Description"
                    onChange={(e) => setCat1(e.target.value)}
                  />
                </Grid>
                <Grid item xs={1}>
                  <label
                    htmlFor={"Description"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Description"}
                  </label>
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    name="Description"
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Grid>
                <Grid item xs={1}>
                  <label
                    htmlFor={"SearchString"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Model_Code"}
                  </label>
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    name="SearchString"
                    onChange={(e) => setSearchString(e.target.value)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <BiztranControls.Button
                    text="SEARCH"
                    startIcon={<SearchIcon />}
                    style={{ marginTop: "0%" }}
                    onClick={() => {
                      PopulateData();
                    }}
                  />
                </Grid>
              </Grid>
              <Grid spacing={2} container direction="row">
                <Grid xs={12}>
                  <BiztranControls.DataGrid
                    rowHeight={25}
                    rows={rows}
                    columns={columns}
                    // hideFooterPagination={false}
                    checkboxSelection
                    disableSelectionOnClick
                    onSelectionModelChange={(newSelection) => {
                      setSelectionModel(newSelection);
                    }}
                    onCellEditCommit={handleCellEditCommit}
                    Height="340px"
                    Width="100%"
                  />
                </Grid>

                <Grid xs={12} style={{ marginTop: 7 }}>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                      }}
                    >
                      <BiztranControls.Button
                        text="Add"
                        startIcon={<SaveIcon />}
                        style={{ marginTop: "0%" }}
                        onClick={() => {
                          onSubmit();
                        }}
                      />
                      <BiztranControls.Button
                        text="Close"
                        startIcon={<CloseOutlined />}
                        style={{ marginTop: "0%" }}
                        onClick={() => props.setOpen(false)}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </Grid>
  );
};

export default AddProduct;
